import { defineComponent as _defineComponent } from 'vue'

export { OzListRowSeparator } from '@@/library/v4/components/OzListRow.vue'
const __default__ = {}

import { isAppUsing } from '@@/bits/flip'
import OzBadge, { OzBadgeColorScheme, OzBadgeSizePreset } from '@@/library/v4/components/OzBadge.vue'
import { __, n__ } from '@@/bits/intl'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzListRow, { OzListRowSeparator } from '@@/library/v4/components/OzListRow.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from '@@/library/v4/components/OzPlainButton.vue'
import OzRelativeTime from '@@/library/v4/components/OzRelativeTime.vue'
import type { Library, WallCamelCase as Wall, Wall as WallSnakeCase } from '@@/types'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzWallListRow',
  props: {
    wall: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    invertColors: { type: Boolean, default: false },
    dateAttribute: { default: 'updatedAt' },
    clickable: { type: Boolean, default: true },
    xMore: { type: Boolean, default: false },
    library: { default: undefined },
    separator: { default: OzListRowSeparator.Short }
  },
  emits: ["select", "more"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'select', wall: Wall | WallSnakeCase): void
  (name: 'more', wall: Wall | WallSnakeCase): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { wall: Wall | WallSnakeCase, darkMode: boolean | 'auto', invertColors: boolean, dateAttribute: string, clickable: boolean, xMore: boolean, library: Library, separator: OzListRowSeparator }





const title = computed((): string => {
  return props.wall.title || __('Untitled padlet')
})

const dominantColorAsRgb = computed((): string => {
  return (
    (props.wall as Wall).thumbnail.dominantColorAsRgb || (props.wall as WallSnakeCase).thumbnail.dominant_color_as_rgb
  )
})

const date = computed((): string => {
  if (props.dateAttribute === 'updatedAt') {
    return (props.wall as Wall).updatedAt || (props.wall as WallSnakeCase).updated_at
  } else {
    return props.wall[props.dateAttribute]
  }
})

const accountDisplayName = computed((): string => {
  const displayName =
    'displayName' in props.wall.builder ? props.wall.builder.displayName : props.wall.builder.display_name
  return props.library ? props.library.name : displayName
})

const daysTillWallIsDeleted = computed((): number => {
  const daysLeft =
    'daysTillDeletion' in props.wall ? props.wall.daysTillDeletion : (props.wall as WallSnakeCase).days_till_deletion
  return daysLeft ?? 0
})

const daysTillDeletedDisplay = computed((): string => {
  return n__('%{num} day left', '%{num} days left', daysTillWallIsDeleted.value, { num: daysTillWallIsDeleted.value })
})

const wallDeletingSoon = computed((): boolean => {
  return daysTillWallIsDeleted.value <= 3
})

const xRelativeTimestamp = computed((): boolean => {
  return props.dateAttribute !== 'trashedAt'
})

const xTemplate = computed((): boolean => {
  if (!isAppUsing('templates')) return false
  if ('isTemplate' in props.wall) {
    return props.wall.isTemplate === true
  }
  return false
})

const select = (): void => {
  emit('select', props.wall)
}

const more = (): void => {
  emit('more', props.wall)
}

return { __sfc: true,props, emit, title, dominantColorAsRgb, date, accountDisplayName, daysTillWallIsDeleted, daysTillDeletedDisplay, wallDeletingSoon, xRelativeTimestamp, xTemplate, select, more, OzBadge, OzBadgeColorScheme, OzBadgeSizePreset, __, ImageThumbnail, OzIcon, OzListRow, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset, OzRelativeTime }
}

})